import React from "react";
import './Main.css';
import { Link } from 'react-router-dom'
import image from '../images/img.jpg'
import image2 from '../images/logo1.png'
import image3 from '../images/img2.jpg'
import Button from "../UI/Button";

const Novosti = () => {

    return(
        <div className="novosti">

            <div className="vjest">
                <img className="vjest-img" src={image} alt=""/>

                <h3 className="vjest-naslov">Ministarstvo prosvjete i kulture</h3>

                <p className="vjest-tekst">U Republici Srpskoj obrazovanje odraslih je sastavni dio sistema obrazovanja
                ,a svoju potvrdu dobilo je donošenjem niza važnih dokumenata.Zavod za obrazovanje odraslih je osnovan kako...
                {/* bi pružio podršku razvoju modernog i fleksibilnog sistema obrazovanja odraslih u Republici Srpskoj koji će pratiti
                zahtjeve tržišta rada, načela cjeloživotnog učenja i primjere najbolje prakse iz zemalja članica EU.
                Zavod za obrazovanje odraslih na organizovan i sistematičan način */}
                </p>
                <a target={'_blank'} rel="noreferrer" href="https://www.vladars.net/sr-SP-Cyrl/Vlada/Ministarstva/mpk/Pages/obrazovanjeodraslih.aspx"><Button /></a>
            </div>

            <div className="vjest">

            <img className="vjest-img" src={image2} alt="" />

                <h3 className="vjest-naslov">Centar za obrazovanje odraslih Bijeljina</h3>

                <p className="vjest-tekst">Vrši upis novih učenika.<br />
                Podaci i informacije o konkursu za školsku 2021/2022.<br />
                <br /> <br /> <br /> <br /> 
                </p>
                <Link to="/konkurs"><Button /></Link>
            </div>

            <div className="vjest">
            <img className="vjest-img" src={image3} alt="" />

                <h3 className="vjest-naslov">Zavod za obrazovanje odraslih</h3>

                <p className="vjest-tekst">
                    Najvažniji koraci u dosadašnjem radu Zavoda su usvajanje Programa rada Zavoda i prijedloga... <br />
                    <br /> <br />   </p>
                <a target={'_blank'} rel="noreferrer" href="http://www.mpoo.org/" ><Button /></a>
            </div>
            
        </div>
    )

}

export default Novosti;